import { writable } from 'svelte/store';

function createMuscleGroups() {
    const { subscribe, set, update } = writable([])

    return {
        subscribe,
        set,
        add: (id) => update(mg => [...mg, id]),
        remove: (id) => update(mg => mg.filter(v => v !== id)),
        reset: () => set([]),
    }
}

export const selectedMuscleGroups = createMuscleGroups();
